/*eslint-disable */

import paymentConfirmationSuccess from '@/components/private/package/payment-confirmation-of-popup/';

export default {
  name: 'payment-success',
  components: {
    'payment-confirmation' : paymentConfirmationSuccess
  },
  props: [],
  data () {
    return {
      paymentConfirmationPopupState:false,
      selfUserId:'',
      subscriptionId:'',
      bearer:'',
      token:'',
      accountActivateState:false
    }
  },
  computed: {

  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    if(this.$route.query.subscription_id){
      this.paymentConfirmationPopupMethod();
      this.subscriptionId = this.$route.query.subscription_id
      this.bearer = this.$route.query.ba_token
      this.token = this.$route.query.token
    }
    setTimeout(() => {
      this.applySubscriptionMethod();
    }, 800);
  },
  methods: {
    paymentConfirmationPopupMethod(){
      this.paymentConfirmationPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    applySubscriptionMethod(){
      let data = {
        user_id:this.selfUserId,
        subscription_id:this.subscriptionId,
        bearer:this.bearer,
        token:this.token
      }
      this.$store.dispatch('userActivateSubscriptionFunc', data).then((res) => {
        this.accountActivateState = true
        this.paymentConfirmationPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.$store.dispatch('getAcUserDetailsFun')
        
      })
    }
  },
}